import { FaDownload, FaEllipsisH, FaFilter, FaRecycle, FaUpload } from 'react-icons/fa';
import * as XLSX from 'xlsx';

import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './DeliveryListe.css';
//import InvoiceForm from '../InvoiceFormx';
import { Badge, Button, Card, CardBody, CardHeader, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Pagination, PaginationItem, PaginationLink, Row, Spinner, UncontrolledDropdown } from 'reactstrap';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleDown, FaAngleLeft, FaAngleRight, FaAngleUp, FaBoxOpen, FaCalendarAlt, FaCheckCircle, FaClock, FaEdit, FaFileExport, FaFileInvoice, FaFilePdf, FaInfoCircle, FaMoneyBillWave, FaPlus, FaScrewdriver, FaSearch, FaTrash, FaTruck } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { devisActions } from '../../sagas/devisSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { deliveryActions } from '../../sagas/deliveryNoteSlice';
import jsPDF from 'jspdf';
import "jspdf-autotable";
import autoTable from 'jspdf-autotable';
import { convertNumberToWords, formatPrice } from '../../helpers/utility';
import BonLivraisonForm from './BonLivraisonForm';
import InvoiceForm from './InvoiceForm';
import Select from "react-select";
import { clientActions } from '../../sagas/clientSlice';
import { commercialActions } from '../../sagas/commercialSlice';
import { generateDoc } from '../../helpers/generateDoc';
import { productActions } from '../../sagas/productSlice';

const DeliveryList = () => {
    const dispatch = useDispatch();
    const { list, totals, totalPages, totalElements, loading } = useSelector((state) => state.deliveryNotes);
    const { company } = useSelector(state => state.auth);
    const [showModal, setShowModal] = useState(false);
    const { t } = useTranslation();
    const [selectedBonLivraison, setSelectedBonLivraison] = useState(null);
    const [checkedDeliveries, setCheckedDeliveries] = useState([]); // State to track checked deliveries
    const [invoice, setInvoice] = useState(null); // State to hold the invoice object
    const [showInvoiceModal, setShowInvoiceModal] = useState(false); // State to control the invoice modal
    const clients = useSelector(state => state.clients.clients);
    const { list: commercialList, loading: commercialLoading } = useSelector((state) => state.commercials); // Adjust state path as needed
    const unites = useSelector(status => status.products.unites); // Assuming you have a Redux store with unites
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(50);

    const fileInputRef = useRef(null);
    const now = new Date();
    const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const tomorrowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const pad = (n) => n.toString().padStart(2, '0');
    const formatDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    const [filters, setFilters] = useState({
        clientId: null,
        commercialId: null,
        dateFrom: formatDate(todayDate),
        dateTo: formatDate(tomorrowDate),
        query: ''
    });
    const [sortConfig, setSortConfig] = useState({
        key: 'clientNom',
        direction: 'asc'
    });
    const [selectedClient, setSelectedClient] = useState(null);

    const searchInputRef = useRef(null);
    const fetchDeliveryData = useCallback((payload) => {
        dispatch(deliveryActions.list(payload));
        const { page, size, ...totalsPayload } = payload || {};
        dispatch(deliveryActions.totals(totalsPayload));
    }, [dispatch]);

    const totalTtcSummary = totals?.totalTTC ?? totals?.montantTotalTTC ?? 0;
    const totalMontantPayeSummary = totals?.totalPaye ?? totals?.montantPaye ?? totals?.montantTotalPaye ?? 0;

    useEffect(() => {
        dispatch(clientActions.search({ query: "" }));
        dispatch(commercialActions.list({ query: "" })); // Fetch categories on component mount
        dispatch(productActions.findAllUnites());
    }, []);

    useEffect(() => {
        let payload = {
            ...filters,
            page: currentPage,
            size: pageSize
        };
        fetchDeliveryData(payload);
    }, [filters.clientId, filters.dateFrom, filters.dateTo, filters.commercialId, currentPage, pageSize, fetchDeliveryData]);

    useEffect(() => {
        // Auto focus on mount
        searchInputRef.current?.focus();

        // Add keyboard shortcut
        const handleKeyDown = (e) => {
            if (e.key === 'F2') {
                e.preventDefault();
                searchInputRef.current?.focus();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [list]);

    // Handle checkbox change for delivery selection
    const handleCheckboxChange = (deliveryId) => {
        setCheckedDeliveries((prevChecked) => {
            if (prevChecked.includes(deliveryId)) {
                return prevChecked.filter((id) => id !== deliveryId);
            } else {
                return [...prevChecked, deliveryId];
            }
        });
    };


    const clearFilters = () => {
        setCurrentPage(0);
        setFilters({
            query: '',
            clientId: null,
            chantierId: null,
            commercialId: null,
            dateFrom: formatDate(todayDate),
            dateTo: formatDate(tomorrowDate)
        });
        debouncedSearch('')
    };

    const handleSort = (key) => {
        setSortConfig((prev) => ({
            key,
            direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
        }));
    };

    const handlePageChange = (page) => {
        if (page < 0 || page >= totalPages || page === currentPage) return;
        setCheckedDeliveries([]);
        setCurrentPage(page);
    };

    const visiblePages = useMemo(() => {
        if (!totalPages || totalPages <= 0) return [];
        const start = Math.max(0, currentPage - 2);
        const end = Math.min(totalPages - 1, currentPage + 2);
        const pages = [];
        for (let i = start; i <= end; i += 1) {
            pages.push(i);
        }
        return pages;
    }, [currentPage, totalPages]);

    const renderSortIcon = (key) => {
        if (sortConfig.key !== key) {
            return <FaAngleUp className="ms-1 text-muted" />;
        }
        return sortConfig.direction === 'asc'
            ? <FaAngleUp className="ms-1" />
            : <FaAngleDown className="ms-1" />;
    };

    const displayedList = useMemo(() => {
        const toNumber = (value) => {
            const parsed = Number(value);
            return Number.isFinite(parsed) ? parsed : 0;
        };

        return [...list]
            .sort((a, b) => {
                let compare = 0;

                if (sortConfig.key === 'clientNom') {
                    const clientA = (a.clientNom || '').trim();
                    const clientB = (b.clientNom || '').trim();
                    compare = clientA.localeCompare(clientB, 'fr', { sensitivity: 'base' });
                } else if (sortConfig.key === 'montantTotalTTC') {
                    compare = toNumber(a.montantTotalTTC) - toNumber(b.montantTotalTTC);
                } else if (sortConfig.key === 'montantPaye') {
                    compare = toNumber(a.montantPaye) - toNumber(b.montantPaye);
                }

                return sortConfig.direction === 'asc' ? compare : -compare;
            });
    }, [list, sortConfig]);

    const clientOptions = clients?.map(client => ({
        value: client.id,
        label: client.typeClient === 'PARTICULIER'
            ? `${client.nom} ${client.prenom || ''} `
            : client.entreprise,
        chantiers: client.chantiers || []
    })) ?? [];

    const clientOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...clientOptions
    ];

    const chantierOptions = selectedClient?.chantiers?.map(chantier => ({
        value: chantier.id,
        label: `${chantier.code} - ${chantier.nom}`,
        ...chantier
    })) || [];

    const chantierOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...chantierOptions
    ];

    const refrechBLs = () => {
        let payload = {
            ...filters,
            page: currentPage,
            size: pageSize
        };
        fetchDeliveryData(payload);
    };

    const commercialOptions = commercialList?.map(com => ({
        value: com.id,
        label: com.fullName,
    })) ?? [];

    const commercialOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...commercialOptions
    ];

    // Handle creating an invoice from selected deliveries
    const handleCreateInvoice = () => {
        if (checkedDeliveries.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: t('common.warning'),
                text: t('delivery.noDeliveriesSelected'),
            });
            return;
        }

        // Get the selected delivery notes
        const selectedDeliveryNotes = list.filter(note => checkedDeliveries.includes(note.id));

        // Check if all selected delivery notes are from the same client and are in confirmed state
        const firstClient = selectedDeliveryNotes[0].clientId;
        const allSameClient = selectedDeliveryNotes.every(note => note.clientId === firstClient);
        const allConfirmed = selectedDeliveryNotes.every(note => note.status === 'LIVRE');

        if (!allSameClient) {
            Swal.fire({
                icon: 'warning',
                title: t('common.warning'),
                text: t('delivery.notesFromDifferentClients'),
            });
            return;
        }



        if (!allConfirmed) {
            Swal.fire({
                icon: 'warning',
                title: t('common.warning'),
                text: t('delivery.notAllDelivered'),
            });
            return;
        }

        // Prepare the invoice object
        const newInvoice = {
            clientId: selectedDeliveryNotes[0].clientId,
            clientNom: selectedDeliveryNotes[0].clientNom,
            deliveryMappings: selectedDeliveryNotes.map(note => ({
                id: note.id,
                numero: note.numero,
                dateLivraison: note.dateLivraison,
                montantTTC: note.montantTotalTTC,
                montantPaye: note.montantPaye
            })),
            lignes: (() => {
                const lineMap = {};

                selectedDeliveryNotes.forEach(note => {
                    note.lignes.forEach(line => {

                        const prixTTC = Number(line.prixUnitaireTTC || 0);
                        const tva = line.tauxTVA;

                        // Unique key = article + TTC price
                        const key = `${line.articleId}-${prixTTC}`;

                        if (!lineMap[key]) {
                            lineMap[key] = {
                                articleId: line.articleId,
                                articleCode: line.articleCode,
                                articleNom: line.articleNom,
                                unite: line.unite,
                                prixUnitaireHT: line.prixUnitaireHT,
                                prixUnitaireTTC: prixTTC,
                                tauxTVA: tva,
                                quantite: 0,
                                montantHT: 0,
                                montantTVA: 0,
                                montantTTC: 0,
                            };
                        }

                        const qty = Number(line.quantiteLivree || 0);
                        const puHT = Number(line.prixUnitaireHT || 0);

                        // accumulate
                        lineMap[key].quantite += qty;
                        lineMap[key].montantHT += line.montantHT;
                        lineMap[key].montantTVA += line.montantTVA;
                        lineMap[key].montantTTC += line.montantTTC;
                    });
                });

                return Object.values(lineMap);
            })(),

            montantTotalHT: selectedDeliveryNotes.reduce((total, note) => total + note.montantTotalHT, 0),
            montantTotalTaxe: selectedDeliveryNotes.reduce((total, note) => total + note.montantTotalTaxe, 0),
            montantTotalTTC: selectedDeliveryNotes.reduce((total, note) => total + note.montantTotalTTC, 0),
            montantTotalPaye: selectedDeliveryNotes.reduce((total, note) => total + (note.montantPaye || 0), 0),
            montantRegle: selectedDeliveryNotes.reduce((total, note) => total + (note.montantPaye || 0), 0),
            modePaiement: selectedDeliveryNotes[0].modePaiement,
            modeReglement: selectedDeliveryNotes[0].modeReglement,
            dateFacture: new Date().toLocaleDateString('en-CA', { timeZone: 'Africa/Casablanca' }), // Current date in YYYY-MM-DD format
            dateEcheance: new Date().toLocaleDateString('en-CA', { timeZone: 'Africa/Casablanca' }), // Current date in YYYY-MM-DD format
            // dateEcheanceCheque: selectedDeliveryNotes[0].dateEcheanceCheque,
            // banque: selectedDeliveryNotes[0].banque,
            // numeroCheque: selectedDeliveryNotes[0].numeroCheque,
        };

        setInvoice(newInvoice);
        setShowInvoiceModal(true);
    };


    const handleCloseInvoiceModal = () => {
        setShowInvoiceModal(false);
        setInvoice(null);
        setCheckedDeliveries([]); // Clear checked deliveries after closing the invoice modal
        let payload = {
            ...filters,
            page: currentPage,
            size: pageSize
        };
        fetchDeliveryData(payload);
    };

    const handleGeneratePdf = async (document, documentType = 'bon_livraison', withPrices = true) => {
        await generateDoc(documentType, {
            matjarDoc: {
                ...document, lignes: document.lignes.map(l => ({
                    ...l,
                    unite: unites.find(u => u.code === l.unite)?.libelle
                }))
            },
            sellerModel: company,
            currency: "MAD",
            showPrices: withPrices,         // false pour BL sans prix
            open: true,               // ouvre dans un nouvel onglet
            download: false,          // si true -> télécharge
        });
    };


    const handleShowModal = () => {
        setShowModal(true);
    };

    const handleEdit = (bl) => {
        setSelectedBonLivraison(bl);
        setShowModal(true);
    }

    const handleAnnulerBL = (br) => {
        Swal.fire({
            title: t('delivery.deleteConfirmTitle'),
            text: t('delivery.deleteConfirmText'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc3545',
            cancelButtonColor: '#6c757d',
            confirmButtonText: t('common.confirm'),
            cancelButtonText: t('common.cancel')
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {

                    let payload = {
                        id: br.id,
                        onSuccess: () => {
                            Swal.fire(t('delivery.deleted'), '', 'success');
                            refrechBLs();
                        },
                        onError: (error) => {
                            Swal.fire({
                                icon: 'error',
                                title: t('delivery.deleteError'),
                                text: t('delivery.deleteErrorMessage')
                            });
                        }
                    }
                    dispatch(deliveryActions.annulerBL(payload));

                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: t('common.error'),
                        text: t('delivery.deleteError')
                    });
                }
            }
        });
    }

    const handleResetBL = (br) => {
        Swal.fire({
            title: t('delivery.resetConfirmTitle'),
            text: t('delivery.resetConfirmText'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc3545',
            cancelButtonColor: '#6c757d',
            confirmButtonText: t('common.confirm'),
            cancelButtonText: t('common.cancel')
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {

                    let payload = {
                        id: br.id,
                        onSuccess: () => {
                            Swal.fire(t('delivery.reseted'), '', 'success');
                            refrechBLs();
                        },
                        onError: (error) => {
                            Swal.fire({
                                icon: 'error',
                                title: t('delivery.resetError'),
                                text: t('delivery.resetErrorMessage')
                            });
                        }
                    }
                    dispatch(deliveryActions.resetBL(payload));

                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: t('common.error'),
                        text: t('delivery.resetError')
                    });
                }
            }
        });
    }



    const handleCloseModal = () => {
        setShowModal(false);
        if (selectedBonLivraison) {
            setSelectedBonLivraison(null);
        }
        let payload = {
            ...filters,
            page: currentPage,
            size: pageSize
        };
        fetchDeliveryData(payload);
    };

    const debouncedSearch = () => {
        setCurrentPage(0);
        fetchDeliveryData({
            ...filters,
            page: 0,
            size: pageSize
        });
    }

    const handleLivrerBL = (bl) => {
        Swal.fire({
            title: t('common.confirm'),
            text: t('bonLivraison.confirmLivrer'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('common.yes'),
            cancelButtonText: t('common.no'),
        }).then((result) => {
            if (!result.isConfirmed) return;
            let payload = {
                id: bl.id,
                data: { ...bl, status: 'LIVRE' },
                onSuccess: () => {
                    Swal.fire({
                        icon: 'success',
                        title: t('common.updated'),
                        text: t('bonLivraison.updatedSuccess'),
                    });
                    let payload = {
                        ...filters,
                        page: currentPage,
                        size: pageSize
                    };
                    fetchDeliveryData(payload);

                },
            };
            dispatch(deliveryActions.update(payload));
        });
    }

    const handleAccuseBL = (bl) => {
        Swal.fire({
            title: t('common.confirm'),
            text: t('bonLivraison.confirmAccuser'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('common.yes'),
            cancelButtonText: t('common.no'),
        }).then((result) => {
            if (!result.isConfirmed) return;
            let payload = {
                id: bl.id,
                data: { ...bl, accuse: true },
                onSuccess: () => {
                    Swal.fire({
                        icon: 'success',
                        title: t('common.updated'),
                        text: t('bonLivraison.updatedSuccess'),
                    });
                    let payload = {
                        ...filters,
                        page: currentPage,
                        size: pageSize
                    };
                    fetchDeliveryData(payload);

                },
            };
            dispatch(deliveryActions.update(payload));
        });
    }

    // Aggregate lines by articleId for display/export
    const aggregateLines = (lines) => {
        const lineMap = {};
        lines.forEach(line => {
            const key = line.articleId;
            if (!lineMap[key]) {
                lineMap[key] = {
                    ...line,
                    quantite: 0,
                    montantHT: 0,
                    montantTVA: 0,
                    montantTTC: 0,
                };
            }
            lineMap[key].quantite += line.quantite;
            lineMap[key].montantHT += line.montantHT || (line.quantite * line.prixUnitaireHT);
            lineMap[key].montantTVA += line.montantTVA || (line.quantite * line.prixUnitaireHT * line.tauxTVA);
            lineMap[key].montantTTC += line.montantTTC || (line.quantite * line.prixUnitaireHT * (1 + line.tauxTVA));
        });
        return Object.values(lineMap);
    };

    return (
        <Container fluid>
            <Row className="mb-4">
                <Col>
                    <Card className="shadow-sm">
                        <CardBody className="d-flex flex-wrap justify-content-between align-items-center gap-2">
                            <h4 className="mb-0 d-flex align-items-center">
                                <FaTruck className="text-primary me-2" />
                                {t('delivery.list')}
                            </h4>
                            <div className="d-flex flex-wrap align-items-center gap-3">
                                <div className="d-flex align-items-center gap-3 small">
                                    <div>
                                        <div className="text-muted">{t('delivery.ventes')}</div>
                                        <div className="fw-bold">{formatPrice(totalTtcSummary, false)}</div>
                                    </div>
                                    <div>
                                        <div className="text-muted">{t('delivery.paiements')}</div>
                                        <div className="fw-bold">{formatPrice(totalMontantPayeSummary, false)}</div>
                                    </div>
                                </div>
                                {/* Primary actions */}
                                <div className="d-flex align-items-center gap-2">
                                    <Button color="primary" onClick={handleShowModal}>
                                        <FaPlus className="me-2" /> {t('delivery.new')}
                                    </Button>
                                    {checkedDeliveries.length > 0 && (
                                        <Button color="success" onClick={handleCreateInvoice}>
                                            <FaFileInvoice className="me-2" />
                                            {t('delivery.createInvoice')}
                                        </Button>
                                    )}
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Card className="shadow-sm">
                <CardBody>
                    {loading ? ( // Show spinner when loading
                        <div className="text-center py-5">
                            <Spinner color="primary" />
                            <div className="mt-2 text-muted">{t('common.loading')}</div>
                        </div>
                    ) : (
                        <>
                            <div className="filter-container mb-4">
                                <Row className="mb-3 g-2 align-items-end">
                                    <Col lg={3} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1">{t('reglement.search')}</Label>
                                            <div className="input-group">
                                                <span className="input-group-text bg-light">
                                                    <FaSearch />
                                                </span>
                                                <Input
                                                    type="text"
                                                    innerRef={searchInputRef}
                                                    placeholder={t('bonLivraison.searchPlaceholder')}
                                                    value={filters.query}
                                                    onChange={e => {
                                                        const value = e.target.value.toUpperCase();
                                                        setCurrentPage(0);
                                                        setFilters(prevFilters => ({
                                                            ...prevFilters,
                                                            query: value
                                                        }));
                                                    }}
                                                    className="text-uppercase"
                                                    style={{ textTransform: 'uppercase' }}
                                                    onKeyDown={e => {
                                                        if (e.key === 'Enter') {
                                                            debouncedSearch();
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                        <FormGroup className="mb-0">
                                            <Label htmlFor="clientId">{t('bonLivraison.client')}:</Label>
                                            <Select
                                                id="clientId"
                                                options={clientOptionsWithAll}
                                                value={clientOptionsWithAll.find(option => option.value === filters.clientId)}
                                                onChange={(selectedOption) => {
                                                    setCurrentPage(0);
                                                    setFilters(f => ({ ...f, clientId: selectedOption ? selectedOption.value : null }));
                                                    setSelectedClient(selectedOption);
                                                }}
                                                placeholder={t('bonLivraison.selectClient')}
                                                isSearchable
                                                menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="commercialId" className="mb-1">Commercial</Label>
                                            <Select
                                                id="commercialId"
                                                options={commercialOptionsWithAll}
                                                value={commercialOptionsWithAll.find(option => option.value === filters?.commercialId) || null}
                                                onChange={(selectedOption) => {
                                                    setCurrentPage(0);
                                                    setFilters(f => ({ ...f, commercialId: selectedOption ? selectedOption.value : null }))
                                                }}
                                                placeholder={t('commercial.select', 'Sélectionner...')}
                                                isSearchable
                                                isClearable
                                                menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="dateFrom" className="mb-1">Date début</Label>
                                            <Input
                                                type="date"
                                                id="dateFrom"
                                                value={filters.dateFrom}
                                                onChange={e => {
                                                    setCurrentPage(0);
                                                    setFilters(f => ({ ...f, dateFrom: e.target.value }))
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="dateTo" className="mb-1">Date fin</Label>
                                            <Input
                                                type="date"
                                                id="dateTo"
                                                value={filters.dateTo}
                                                onChange={e => {
                                                    setCurrentPage(0);
                                                    setFilters(f => ({ ...f, dateTo: e.target.value }))
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={1} md={1} sm={6} xs={12} className="d-flex align-items-end">
                                        <Button
                                            color="secondary"
                                            onClick={clearFilters}
                                            title={t('common.clearFilters')}
                                            className="mb-3"
                                            style={{ minHeight: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        >
                                            <FaFilter />
                                        </Button>
                                    </Col>
                                </Row>
                            </div>

                            <table className="table table-hover table-striped table-bordered" style={{ fontSize: '0.8rem' }}>
                                <thead className="thead-light">
                                    <tr>
                                        {/* Add checkbox column */}
                                        <th className="align-middle text-center" width="20">
                                            <div className="form-check">
                                                <Input
                                                    type="checkbox"
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            // Only select deliveries that are in LIVRE status
                                                            const deliveredIds = displayedList
                                                                .filter(bl => bl.status === 'LIVRE' && !bl.estFacture)
                                                                .map(bl => bl.id);
                                                            setCheckedDeliveries(deliveredIds);
                                                        } else {
                                                            setCheckedDeliveries([]);
                                                        }
                                                    }}
                                                    checked={
                                                        checkedDeliveries.length > 0 &&
                                                        checkedDeliveries.length === displayedList.filter(bl => bl.status === 'LIVRE' && !bl.estFacture).length
                                                    }
                                                />
                                            </div>
                                        </th>
                                        <th className="align-middle text-center">{t('delivery.numero')}</th>
                                        <th
                                            className="align-middle text-center"
                                            style={{ cursor: 'pointer', userSelect: 'none' }}
                                            onClick={() => handleSort('clientNom')}
                                        >
                                            {t('commande.client')}
                                            {renderSortIcon('clientNom')}
                                        </th>
                                        <th className="align-middle text-center">{t('commande.dateCreation')}</th>
                                        <th className="align-middle text-center">{t('delivery.commercial')}</th>
                                        <th
                                            className="align-middle text-center"
                                            style={{ cursor: 'pointer', userSelect: 'none' }}
                                            onClick={() => handleSort('montantTotalTTC')}
                                        >
                                            {t('devis.montantTTC')}
                                            {renderSortIcon('montantTotalTTC')}
                                        </th>
                                        <th
                                            className="align-middle text-center"
                                            style={{ cursor: 'pointer', userSelect: 'none' }}
                                            onClick={() => handleSort('montantPaye')}
                                        >
                                            {t('reglement.montantPaye')}
                                            {renderSortIcon('montantPaye')}
                                        </th>
                                        <th className="align-middle text-center">{t('delivery.status')}</th>
                                        <th className="align-middle text-center">{t('delivery.regle')}</th>
                                        <th className="align-middle text-center">{t('delivery.facture')}</th>
                                        <th className="align-middle text-center">{t('common.actions')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {displayedList.map((bl) => (
                                        <tr key={bl.id}>
                                            {/* Add checkbox for each row */}
                                            <td className="align-middle text-center">
                                                {bl.status === 'LIVRE' && !bl.estFacture && (
                                                    <Input
                                                        type="checkbox"
                                                        checked={checkedDeliveries.includes(bl.id)}
                                                        onChange={() => handleCheckboxChange(bl.id)}
                                                    />
                                                )}
                                            </td>
                                            <td className="align-middle text-center">{bl.numero}</td>
                                            <td className="align-middle text-center">
                                                {bl.clientNom || 'N/A'}
                                            </td>
                                            <td className="align-middle text-center">{bl.createdAt || 'N/A'}</td>
                                            <td className="align-middle text-center">{bl.commercialNom || 'LOCAL'}</td>
                                            <td className="align-middle text-center">{formatPrice(bl.montantTotalTTC, false)}</td>
                                            <td className="align-middle text-center">{formatPrice(bl.montantPaye, false)}</td>
                                            <td className="align-middle text-center">
                                                {bl.status === 'EN_PREPARATION' && (
                                                    <span className="badge bg-warning">{t('delivery.enpreparation')}</span>
                                                )}
                                                {bl.status === 'EN_COURS' && (
                                                    <span className="badge bg-secondary">{t('delivery.encours')}</span>
                                                )}
                                                {bl.status === 'LIVRE' && (
                                                    <span className="badge bg-success">{t('delivery.livre')}</span>
                                                )}
                                                {bl.status === 'ANNULE' && (
                                                    <span className="badge bg-danger">{t('delivery.annule')}</span>
                                                )}
                                            </td>

                                            <td className="align-middle text-center">
                                                <input
                                                    type="checkbox"
                                                    checked={bl.estRegle}
                                                    readOnly
                                                />
                                            </td>
                                            {/* Add facture status column */}
                                            <td className="align-middle text-center">
                                                <input
                                                    type="checkbox"
                                                    checked={bl.estFacture}
                                                    readOnly
                                                />
                                            </td>

                                            <td className="align-middle text-center">
                                                <div className="btn-group">
                                                    {/* Add dropdown for PDF options */}
                                                    {bl.status !== 'ANNULE' && <UncontrolledDropdown>
                                                        <DropdownToggle caret color="secondary" size="sm"
                                                            className='me-1'>
                                                            <FaFilePdf />
                                                        </DropdownToggle>
                                                        <DropdownMenu>
                                                            <DropdownItem onClick={() => handleGeneratePdf(bl, 'bon_livraison', true)}>
                                                                {t('delivery.pdfWithPrices')}
                                                            </DropdownItem>
                                                            <DropdownItem onClick={() => handleGeneratePdf(bl, 'bon_livraison', false)}>
                                                                {t('delivery.pdfWithoutPrices')}
                                                            </DropdownItem>
                                                        </DropdownMenu>
                                                    </UncontrolledDropdown>}
                                                    {bl.status === 'EN_PREPARATION' && <Button
                                                        color="success"
                                                        title={t('bonLivraison.livrer')}
                                                        onClick={() => handleLivrerBL(bl)}
                                                        className='me-1'
                                                        size="sm"
                                                    >
                                                        <FaCheckCircle />
                                                    </Button>}
                                                    {/* {bl.status === 'LIVRE' && !bl.accuse && <Button
                                                        color="success"
                                                        title={t('bonLivraison.accuser')}
                                                        onClick={() => handleAccuseBL(bl)}
                                                        className='me-1'
                                                        size="sm"
                                                    >
                                                        <FaCheckCircle />
                                                    </Button>} */}
                                                    <Button
                                                        color="warning"
                                                        title={t('commande.edit')}
                                                        onClick={() => handleEdit(bl)}
                                                        size="sm"
                                                        className="me-1"
                                                    >
                                                        <FaEdit />
                                                    </Button>
                                                    {bl.status !== 'ANNULE' && <Button
                                                        color="danger"
                                                        title={t('commande.cancel')}
                                                        onClick={() => handleAnnulerBL(bl)}
                                                        className='me-1'
                                                        size="sm"
                                                    >
                                                        <FaTrash />
                                                    </Button>}
                                                    {bl.status === 'LIVRE' && <Button
                                                        color="success"
                                                        title={t('commande.reset')}
                                                        onClick={() => handleResetBL(bl)}
                                                        className='me-1'
                                                        size="sm"
                                                    >
                                                        <FaRecycle />
                                                    </Button>}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    {displayedList.length === 0 && (
                                        <tr>
                                            <td colSpan="11" className="text-center py-4">
                                                <div className="text-muted">{t('delivery.noBL')}</div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                <tfoot>
                                    <tr className="bg-light fw-bold">
                                        <td colSpan="5" className="text-end">{t('common.totals')}</td>
                                        <td className="text-center">{formatPrice(displayedList.reduce((sum, bl) => sum + (bl.montantTotalTTC || 0), 0), false)}</td>
                                        <td className="text-center">{formatPrice(displayedList.reduce((sum, bl) => sum + (bl.montantPaye || 0), 0), false)}</td>
                                        <td colSpan="4"></td>
                                    </tr>
                                </tfoot>
                            </table>
                            <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mt-2">
                                <div className="d-flex align-items-center gap-2">
                                    <Label for="pageSize" className="mb-0">Taille page</Label>
                                    <Input
                                        id="pageSize"
                                        type="select"
                                        value={pageSize}
                                        onChange={(e) => {
                                            const nextSize = Number(e.target.value);
                                            setPageSize(nextSize);
                                            setCurrentPage(0);
                                        }}
                                        style={{ width: '90px' }}
                                    >
                                        <option value={20}>20</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </Input>
                                    <span className="text-muted small">
                                        {totalElements || 0} élément(s)
                                    </span>
                                </div>
                                <Pagination size="sm" className="mb-0">
                                    <PaginationItem disabled={currentPage <= 0}>
                                        <PaginationLink first onClick={() => handlePageChange(0)} />
                                    </PaginationItem>
                                    <PaginationItem disabled={currentPage <= 0}>
                                        <PaginationLink previous onClick={() => handlePageChange(currentPage - 1)} />
                                    </PaginationItem>
                                    {visiblePages.map((page) => (
                                        <PaginationItem key={page} active={page === currentPage}>
                                            <PaginationLink onClick={() => handlePageChange(page)}>
                                                {page + 1}
                                            </PaginationLink>
                                        </PaginationItem>
                                    ))}
                                    <PaginationItem disabled={totalPages <= 0 || currentPage >= totalPages - 1}>
                                        <PaginationLink next onClick={() => handlePageChange(currentPage + 1)} />
                                    </PaginationItem>
                                    <PaginationItem disabled={totalPages <= 0 || currentPage >= totalPages - 1}>
                                        <PaginationLink last onClick={() => handlePageChange(totalPages - 1)} />
                                    </PaginationItem>
                                </Pagination>
                            </div>
                        </>)}
                </CardBody>
            </Card>
            <Modal isOpen={showModal} toggle={handleCloseModal} size="xl"
                className="modal-fullscreen-lg-down"
                style={{ maxWidth: '95%', width: '95%', margin: '10px auto' }}
            >
                <ModalHeader toggle={handleCloseModal}>{selectedBonLivraison ? `${t('bonLivraison.edit')} N° ${selectedBonLivraison.numero}` : t('bonLivraison.new')}</ModalHeader>
                <ModalBody>
                    <BonLivraisonForm bonLivraison={selectedBonLivraison} onClose={handleCloseModal} />
                </ModalBody>
            </Modal>

            {/* Add Invoice Modal */}
            <Modal isOpen={showInvoiceModal} toggle={handleCloseInvoiceModal} size="xl"
                className="modal-fullscreen-lg-down"
                style={{ maxWidth: '95%', width: '95%', margin: '10px auto' }}
            >
                <ModalHeader toggle={handleCloseInvoiceModal}>
                    {t('facture.newInvoice')}
                </ModalHeader>
                <ModalBody>
                    {invoice && (
                        <InvoiceForm
                            initialValues={invoice}
                            onClose={handleCloseInvoiceModal}
                        />
                    )}
                </ModalBody>
            </Modal>
        </Container>
    );
};

export default DeliveryList;



